import type React from "react";
import { Link } from "react-router-dom";

import { ROUTES } from "../../utils/constants";

const Footer: React.FC = () => {
  return (
    <footer className='border-t bg-background'>
      <div className='container py-8 md:py-12'>
        <div className='grid grid-cols-1 gap-8 md:grid-cols-5'>
          <div className='size-full space-y-4'>
            <img
              src='/images/logos/LK/logo-lk.png'
              alt='PlayArena'
              className='size-full object-cover'
            />
          </div>
          <div className='space-y-4'>
            <div className='flex items-center space-x-2'>
              <span className='text-xl font-bold'>PlayArena</span>
            </div>
            <p className='text-sm text-muted-foreground'>
              Book sports grounds, manage events, and connect with sports world in Sri Lanka.
              PlayArena offers real-time booking, secure payments, and comprehensive venue
              management for cricket, rugby, football, and more.
            </p>
          </div>

          <div className='space-y-4'>
            <h4 className='text-sm font-semibold'>Platform</h4>
            <ul className='space-y-2 text-sm'>
              <li>
                <Link to={ROUTES.GROUNDS} className='text-muted-foreground hover:text-foreground'>
                  Browse Grounds
                </Link>
              </li>
              <li>
                <Link to={ROUTES.EVENTS} className='text-muted-foreground hover:text-foreground'>
                  Find Events
                </Link>
              </li>
              <li>
                <Link to='#' className='text-muted-foreground hover:text-foreground'>
                  How it Works
                </Link>
              </li>
            </ul>
          </div>

          <div className='space-y-4'>
            <h4 className='text-sm font-semibold'>Support</h4>
            <ul className='space-y-2 text-sm'>
              <li>
                <Link to='#' className='text-muted-foreground hover:text-foreground'>
                  Help Center
                </Link>
              </li>
              <li>
                <Link to='#' className='text-muted-foreground hover:text-foreground'>
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to='#' className='text-muted-foreground hover:text-foreground'>
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          <div className='space-y-4'>
            <h4 className='text-sm font-semibold'>Legal</h4>
            <ul className='space-y-2 text-sm'>
              <li>
                <Link to='#' className='text-muted-foreground hover:text-foreground'>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to='#' className='text-muted-foreground hover:text-foreground'>
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to='#' className='text-muted-foreground hover:text-foreground'>
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className='mt-8 border-t pt-8 text-center text-sm text-muted-foreground'>
          <p>© {new Date().getFullYear()} PlayArena. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
